import React from "react";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import { Box, Typography } from "@mui/material";

const PlanData = [
  {
    name: "Basic",
    price: "$0",
    duration: "per month",
    features: [
      "Access to Basic Features",
      "Limited Student Profiles",
      "Email Support",
    ],
  },
  {
    name: "Standard",
    price: "$29",
    duration: "per month",
    features: [
      "All Features",
      "Unlimited Student Profiles",
      "Priority Email Support",
    ],
  },
  {
    name: "Pro",
    price: "$49",
    duration: "per month",
    features: ["All Standard Features", "Advanced Reporting", "24/7 Support"],
  },
];

const Plans = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", pt: 5 }}>
      <Typography
        sx={{
          textAlign: "center",
          fontSize: "2.25rem",
          lineHeight: "2.5rem",
          fontWeight: 600,
        }}
      >
        Affordable Plans for Every School
      </Typography>
      <Typography
        sx={{
          p: 1,
          textAlign: "center",
          fontSize: "1rem",
          lineHeight: "1.5rem",
          color: "rgba(71, 85, 105, 1)",
        }}
      >
        Choose a plan that fits your school's needs and budget. Enjoy
        comprehensive features and dedicated support.
      </Typography>
      <Box
        sx={{
          display: { lg: "flex", md: "flex", xs: "block" },
          justifyContent: "center",
          pt: 3,
          // px: "1rem",
          maxWidth: "80rem",
        }}
      >
        {PlanData.map((item) => {
          return (
            <Box
              key={item.name}
              sx={{
                border: "1px solid #bfdbfe",
                p: "1.5rem",
                borderRadius: "1rem",
                m: 1,
                my: 2,
                width: "100%",
              }}
            >
              <Typography
                sx={{
                  fontSize: "1.125rem",
                  fontWeight: 600,
                  textAlign: "center",
                }}
              >
                {item.name}
              </Typography>
              <Typography
                sx={{
                  fontSize: "3rem",
                  fontWeight: "bolder",
                  textAlign: "center",
                  pt: 1,
                }}
              >
                {item.price}
              </Typography>
              <Typography
                sx={{
                  color: "#6b7c91",
                  fontSize: "1rem",
                  fontWeight: 400,
                  textAlign: "center",
                }}
              >
                {item.duration}
              </Typography>

              {item?.features.map((featureItem) => {
                return (
                  <Box sx={{ p: 1 }} key={featureItem}>
                    <CheckIcon sx={{ color: "#347AEA", alignSelf: "center" }} />
                    {featureItem}
                  </Box>
                );
              })}
              <Box sx={{ mt: 4, textAlign: "center" }}>
                <Button
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    borderRadius: 1,
                    backgroundColor: "#347AEA",
                    alignSelf: "center",
                    // px: 5,
                  }}
                >
                  Start free trail
                </Button>
              </Box>

              <Box
                sx={{
                  fontSize: "0.875rem",
                  mt: 1,
                  color: "rgba(71, 85, 105, 1)",
                  textAlign: "center",
                }}
              >
                No credit card required
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default Plans;
